<template>
    <div
        class="img-swiper-wrapper"
        :class="[{ isMobile: platform.isMobile }]"
    >
        <div class="slot-wraper" v-if="allImages.length">
            <Swiper
                class="swiper-box"
                v-bind="swiperOption"
                v-if="refresh"
                @slideChange="handleSlideChange"
            >
                <Slide v-for="(item, index) in allImages" :key="index">
                    <div
                        v-show="showLoadingImg && loadedStates[item] !== true"
                        class="loading-box"
                    >
                        <div class="mg-loading"></div>
                    </div>
                    <div
                        class="img-content"
                        :style="{
                            zIndex: (showLoadingImg && loadedStates[item] !== true) ? '-1' : '0'
                        }"
                    >
                        <site-img
                            :src="item"
                            :dir="dir"
                            type="img"
                            :alt="alt"
                            :lazy="lazy"
                            :errorImg="errorImg"
                            @update="imgUpdate(item)"
                            @load="imgLoad($event, item)"
                            @error="imgError($event, index)"
                        />
                    </div>
                </Slide>
            </Swiper>
            <slot></slot>
        </div>
        <slot name="mask"></slot>
        <template v-if="showSwitch && allImages.length > slidesPerView">
            <slot name="button-prev">
                <div class="swiper-prev iconfont icon-arrow_08_left"></div>
            </slot>
            <slot name="button-next">
                <div class="swiper-next iconfont icon-arrow_08_right"></div>
            </slot>
        </template>
    </div>
</template>

<script>
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
// import util from '@/common/util';
export default {
    emits: ['change', 'load', 'error'],
    data: function() {
        return {
            curPage: 0, //  current page
            slidesPerView: 1,
            refresh: true,
            loadedStates: {},
            isMounted: false
        };
    },
    components: {
        Swiper: Swiper,
        Slide: SwiperSlide
    },
    props: {
        dir: {
            type: String,
            default: () => 'width'
        },
        alt: {
            type: String,
            default: ''
        },
        lazy: {
            // site-img lazy
            type: Boolean,
            default: false
        },
        showLoadingImg: {
            //  whether to display loading picture
            type: Boolean,
            default: true
        },
        errorImg: {
            type: String,
            default: ''
        },
        allImagesJson: {
            type: String,
            default: () => ''
        },
        speed: {
            type: Number,
            default: 1000
        },
        spaceBetween: {
            type: Number,
            default: 10
        },
        showSwitch: {
            // Whether to display the left and right switching arrows of the picture
            type: Boolean,
            default: true
        }
    },
    computed: {
        allImages({ allImagesJson }) {
            try {
                return allImagesJson ? JSON.parse(allImagesJson) : [];
            } catch (e) {
                return [];
            }
        },
        swiperOption({ spaceBetween, speed, slidesPerView, isMounted, showSwitch }) {
            let options = {
                allowSlideNext: showSwitch,
                spaceBetween,
                speed,
                slidesPerView,
                navigation: {
                    closest: '.img-swiper-wrapper',
                    prevEl: '.swiper-prev',
                    nextEl: '.swiper-next'
                },
                virtual: {
                    // from: 0,
                    // to:1,
                    addSlidesAfter: 2,
                    addSlidesBefore: 2
                },
                nested: true
            };

            // if(isClient || isMounted){
            //     options.virtual = {
            //         addSlidesAfter: 2,
            //         addSlidesBefore: 2
            //     }
            // }
            return fixSwiperOptions(options);
        }
    },
    inject: {
        noImgLazy: { default: false }
    },
    mounted() {
        this.isMounted = true;
    },
    methods: {
        handleSlideChange(swiper) {
            let index = swiper.activeIndex + 1;
            this.$emit('change', index);
            this.curPage = index;
        },
        imgUpdate(item) {
            this.loadedStates[item] = false;
        },
        imgLoad($event, item) {
            this.loadedStates[item] = true;
            this.$emit('load', { ...$event, item });
        },
        imgError($event) {
            this.$emit('error', $event);
        }
    },
    watch: {
        swiperOption: {
            deep: true,
            handler() {
                this.refresh = false
                this.$nextTick(() => {
                    this.refresh = true
                })
            }
        }
    }
};
</script>

<style lang="scss">
@import '../theme/mixin.scss';
.img-swiper-wrapper {
    .slot-wraper {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0px;
        .swiper-box {
            height: 100%;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .swiper-prev,
    .swiper-next {
        position: absolute;
        z-index: 2;
        height: 50px;
        color: white;
        top: 50%;
        display: none;
        transform: translate(0, -50%);
        justify-content: center;
        align-items: center;
        font-weight: 700;
        font-size: 18px;
    }
    .swiper-prev {
        left: 0px;
    }
    .swiper-next {
        right: 0px;
    }
    .swiper-button-disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
    &.isMobile:hover .swiper-next,
    &.isMobile:hover .swiper-prev {
        display: none;
    }
    &:hover .swiper-prev,
    &:hover .swiper-next {
        display: flex;
    }
    .img-content {
        width: 100%;
        height: 100%;
    }
}
</style>
